import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/footer'
import PageHead from '../Component/pageHead'
import PageSubHead from '../Component/pageSubHead'
import PageBody from '../Component/pageBody'
import { GetAction } from '../Component/GetAction'

function PageView() {
  const { pageId } = useParams()
  const [title, setTitle] = useState('')
  const [subtitle, setSubTitle] = useState('')
  const [markup, setMarkup] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      setLoading(true)
      try {
        const res = await GetAction('get', { page_id: pageId }, '/pages/page')
        const response = res?.response
        if (!cancelled && response) {
          setTitle(response.title || '')
          setSubTitle(response.subTitle || '')
          setMarkup(response.description || '')
        } else if (!cancelled) {
          setTitle('')
          setSubTitle('')
          setMarkup('')
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [pageId])

  const static_markup = { __html: markup || '' }

  return (
    <>
      <Header />
      <PageHead title={title} />
      <PageSubHead title={subtitle} />
      <div className="container" style={{ fontSize: 20, minHeight: '500px' }}>
        {loading ? <p className="text-center text-muted">Loading...</p> : null}
        {!loading && markup ? <PageBody data={static_markup} /> : null}
        {!loading && !markup ? (
          <p className="text-center text-muted">Content is not available right now.</p>
        ) : null}
      </div>
      <Footer />
    </>
  )
}

export default PageView
